import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-work-finish',
  templateUrl: './finish.component.html',
  styleUrls: ['./finish.component.css'],
})

export class ExerciseFinishComponent implements OnInit{
  @Input() isNeedCorrect: boolean;
  @Output() finishAnswer = new EventEmitter<any>();
  assetsRoute: string = "../../../assets";


  constructor(
  ) {}

  ngOnInit() {
  }

  ngAfterViewInit(){

  }

  goAnswer(tabNum):void{
    this.finishAnswer.emit(tabNum);
  }


}



// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work-finish/finish.component.ts